module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/acchead-grid/acchead-grid.component.css
// module id = ./src/app/finance/acchead-grid/acchead-grid.component.css
// module chunks = main